<template>
  <v-btn
    class="go-to-top-button"
    size="large"
    icon
    color="primary"
    @click="scrollToTop"
  >
    <v-icon>mdi-arrow-collapse-up</v-icon>
  </v-btn>
</template>

<script>
export default {
  data: () => ({
    buttonPosition: -40, // Adjust base position as needed
  }),
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
.go-to-top-button {
  position: fixed;
  right: 50px;
  bottom: 30px;
}
</style>
